module.exports = __webpack_public_path__ + "img/gems_ic.99d43181.svg";